import CaseNumberInput from './input';

export default CaseNumberInput;
